module.exports = __webpack_public_path__ + "img/keyVisual.8a911a0f.svg";